import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  InputPassword,
} from "@altimateai/lego";
import { Control } from "react-hook-form";
import { SnowflakeConnectionType } from "@/pages/datastores/types";
import { SnowflakeFormValues } from "../SnowflakeConnection";

interface SnowflakeFormFieldsProps {
  control: Control<SnowflakeFormValues>;
  authType: SnowflakeConnectionType;
}

export const SnowflakeFormFields = ({ control, authType }: SnowflakeFormFieldsProps) => {
  return (
    <>
      <FormField
        control={control}
        name="username"
        render={({ field }) => (
          <FormItem>
            <FormLabel>User</FormLabel>
            <FormControl>
              <Input
                {...field}
                placeholder="altimate_user"
                autoComplete="new-password"
                className="al-mt-1"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="auth_type"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Authentication Type</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className="al-w-56">
                  <SelectValue placeholder="Select an authentication type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value={SnowflakeConnectionType.PASSWORD}>
                  Username/Password
                </SelectItem>
                <SelectItem value={SnowflakeConnectionType.KEY_PAIR}>Key Pair</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {authType === SnowflakeConnectionType.PASSWORD && (
        <FormField
          control={control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="password">Password</FormLabel>
              <FormControl>
                <InputPassword
                  id="password"
                  {...field}
                  autoComplete="new-password"
                  className="al-mt-1"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      <FormField
        control={control}
        name="role"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Role</FormLabel>
            <FormControl>
              <Input {...field} placeholder="ALTIMATE_ROLE" className="al-mt-1" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
